/** The exception type and fingerprint the browser network-failure metric alert reads. */
export const FETCH_NO_RESPONSE = 'FetchNoResponseError';

export const FETCH_NO_RESPONSE_MESSAGES = [
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
];

/** Suppress recaptures after apiFetch or callServerAction sends a sanitized no-response warning. */
export const reportedFetchNoResponseErrors = new WeakSet<Error>();

let lastVisibleAt: number | undefined;
let lastResponseAt: number | undefined;

if (typeof document !== 'undefined') {
  if (document.visibilityState === 'visible') {
    lastVisibleAt = Date.now();
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      lastVisibleAt = Date.now();
    }
  });
}

/** Any received HTTP response counts, including an application refusal. */
export function recordSameOriginResponse(url?: string) {
  if (
    typeof document !== 'undefined' &&
    (!url ||
      new URL(url, document.baseURI).origin ===
        new URL(document.baseURI).origin)
  ) {
    lastResponseAt = Date.now();
  }
}

function elapsedBucket(timestamp: number | undefined, now: number): string {
  if (timestamp === undefined) {
    return 'none';
  }
  const elapsed = now - timestamp;
  if (elapsed < 1000) {
    return '<1s';
  }
  if (elapsed < 5000) {
    return '1-5s';
  }
  if (elapsed < 30000) {
    return '5-30s';
  }
  if (elapsed <= 300000) {
    return '30s-5m';
  }
  return '>5m';
}

export function fetchNoResponseContext(error: unknown) {
  const now = Date.now();
  // A browser's message can quote the request URL; only its name leaves the tab.
  const tags: Record<string, string> = {
    feature: 'api-fetch',
    since_visible: elapsedBucket(lastVisibleAt, now),
    since_last_ok: elapsedBucket(lastResponseAt, now),
    fetch_error_name:
      error instanceof Error ? error.name.slice(0, 64) : typeof error,
  };
  if (typeof navigator !== 'undefined') {
    tags.browser_online = String(navigator.onLine);
  }
  if (typeof document !== 'undefined') {
    tags.page_visibility = document.visibilityState;
  }
  return {
    level: 'warning' as const,
    fingerprint: ['api-fetch', FETCH_NO_RESPONSE],
    tags,
  };
}
